import { IconEdit, IconFolder, IconMessageCircle, IconNews, IconWorld } from '@tabler/icons-react';

import type { MobileBottomNavItem } from '@/components/ui/MobileBottomNav';
import { ROUTES } from '@/configs/routes';
import type { TopLevelSectionSlug } from '@/entities/OrganizationSection';

export type OrganizationBottomNavKey = TopLevelSectionSlug;

const BOTTOM_NAV_ORDER: OrganizationBottomNavKey[] = ['documents', 'news', 'notebook', 'macro', 'chat'];

const BOTTOM_NAV_ITEMS_BY_KEY: Record<OrganizationBottomNavKey, MobileBottomNavItem> = {
  documents: { key: 'documents', label: 'Документы', icon: <IconFolder size={24} /> },
  news: { key: 'news', label: 'Новости', icon: <IconNews size={24} /> },
  notebook: { key: 'notebook', label: 'Заметки', icon: <IconEdit size={24} /> },
  macro: { key: 'macro', label: 'Макро', icon: <IconWorld size={24} /> },
  chat: { key: 'chat', label: 'Чат', icon: <IconMessageCircle size={24} /> },
};

export const getBottomNavItems = (enabledSections: OrganizationBottomNavKey[]): MobileBottomNavItem[] => {
  return BOTTOM_NAV_ORDER.filter((sectionKey) => enabledSections.includes(sectionKey)).map(
    (sectionKey) => BOTTOM_NAV_ITEMS_BY_KEY[sectionKey],
  );
};

export const getBottomNavRoute = (key: OrganizationBottomNavKey, organizationId: string) => {
  switch (key) {
    case 'documents':
      return ROUTES.organization.documents.create(organizationId);
    case 'news':
      return ROUTES.organization.news.create(organizationId);
    case 'notebook':
      return ROUTES.organization.notebook.notes.create(organizationId);
    case 'macro':
      return ROUTES.organization.macro.create(organizationId);
    case 'chat':
      return ROUTES.organization.documents.chat.create(organizationId);
    default:
      return ROUTES.organization.documents.create(organizationId);
  }
};
